var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods-wrap"},[_c('webview',{attrs:{"src":"https://m.kuaidi100.com/help/contraband.html"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }